import { useEffect, useRef, useState } from 'react'
import { DataGridProProps as MUIDataGridProps } from '@microservices/wiskey-react-table-component'

import {
  useFetchAllDictionariesMutation,
  useFetchAllDictionaryCategoriesQuery,
  useFetchDictionariesByCategoryCodeForInfiniteScrollMutation,
} from '@redux/api'

import { GETDictionaryByCategoryCode, GETObjectDataParams } from '@types'

import { useInfiniteScroll } from '../../../hooks/infiniteScroll'

export const useConfigDictionary = () => {
  const [categoryId, setCategoryId] = useState<string | undefined>(undefined)
  const skipInit = useRef(false)
  const { data: dictionaryCategories } = useFetchAllDictionaryCategoriesQuery()

  const useFetchDictionaries = categoryId
    ? useFetchDictionariesByCategoryCodeForInfiniteScrollMutation
    : useFetchAllDictionariesMutation

  const dictionaryParamsRequest = categoryId ? { categoryId } : {}

  const {
    combinedData: dictionariesData,
    isLoading: dictionariesIsLoading,
    totalPages: countPage,
    readMore,
    refetch,
  } = useInfiniteScroll<GETObjectDataParams | { categoryId: string }, GETDictionaryByCategoryCode>(
    useFetchDictionaries,
    dictionaryParamsRequest
  )

  useEffect(() => {
    if (skipInit.current) {
      refetch()
    } else {
      skipInit.current = true
    }
  }, [categoryId])

  const handleSelectCategory = (catCode: string) => {
    setCategoryId(catCode)
  }

  const handleResetCategory = () => setCategoryId(undefined)

  const handleLoadMore: MUIDataGridProps['onRowsScrollEnd'] = () => {
    readMore()
  }

  return {
    state: {
      categoryId,
    },
    data: {
      dictionariesData,
      dictionariesIsLoading,
      dictionaryCategories,
      countPage,
    },
    handlers: {
      handleSelectCategory,
      handleResetCategory,
      handleLoadMore,
    },
  }
}
